
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';

import {useTranslation} from 'react-i18next';
import { getData } from '../../helpers/indexedDbHelper';
import ListProducts from './ListProducts';
import SpecialsScreen from './specials';


function Index({setshowCategories}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const [menus, setMenus] = useState([]);
    const [showListProduct, setShowListProduct] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
     const [dishs, setdishs] = useState(false);
    
    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
            setMenus(data);
        });
    }, []);

    
    return (
        <div style={{ position: 'absolute', top: 1, left: 0, width: '100%', height: '100%', zIndex: 9999 }}>
            <LayoutContent showLamp={ false} showBack={true} showImageTop={false}  setShowListProduct={setshowCategories} goHome={setshowCategories} setShowSpecials={setShowSpecials}>
                <div  style={{padding: '0 20px', overflow: 'scroll', height: 790, background: 'white', paddingTop: 20,borderRadius: 30}}>
                    <div style={{display:"flex", justifyContent: 'space-between', flexWrap: "wrap", gap: 10}}>
                        {menus.map((item, key) => {
                            if (![443, 444, 445, 446, 447, 448, 449, 450, 429, 430, 425, 424, 555, 565, 564, 566].includes(item.id)) {
                                return <div key={key} style={{
                                display: 'flex',
                                alignItems: "center",
                                justifyContent: 'center',
                                width: 328,
                                    position: "relative",
                                    border: '5px solid #F90909',
                                    borderRadius: 20,
                                 overflow: 'hidden'
                            }}
                                onClick={() => { 
                                    setShowListProduct(true)
                                    setdishs(item)
                                }}
                                >
                                    {/* fontFamily: 'WallAxe', */}
                                <p className='text-shadow' style={{position: 'absolute',  color: 'white', fontWeight: "900",fontSize: 30}}>{item.name}</p>
                                <img
                                    src={`https://tumenu.online/images/categories/icons/${item.icon}`}
                                    style={{
                                        width: '100%',
                                        height: 220,
                                        objectFit: 'cover',
                                         pointerEvents: 'none',
                                    }}
                                />

                            </div>
                            }
                            
                        })}
                    </div>
                   
                </div>

                {showListProduct && <ListProducts
                    dishs={dishs}
                    setShowListProduct={setShowListProduct}
                    goHome={setshowCategories}
                />}

                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={setshowCategories} />}
               
            </LayoutContent>
        </div>
    );
}
export default Index;